import suiteService from 'qreventos-suite/services';
import turnosService from 'qreventos-suite/turnos';

class SuiteConfig {
  evento: number = 856;
  token: string = 'bUJldXJDYnNJRVdFdVVCL3FnbmI4SSt4d09sd2VOSjg4WkF5WUZtTS9rTT0=';
  clientId: string = 'acb5e13b-3769-4c47-9bf0-978a1b566c95-856';

  public constructor() {
    suiteService.clientId = this.clientId;
    suiteService.token = this.token;
    turnosService.clientId = this.clientId;
    turnosService.token = this.token;
  }
}

export default new SuiteConfig();